import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-admin-view',
    templateUrl: './admin-view.component.html',
    styleUrls: ['./admin-view.component.scss'],
    standalone: false
})
export class AdminViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
 